<template>
    <div>
      <van-sticky :offset-top="0">
        <van-nav-bar
        title="编辑信息"
        left-text="返回"
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"/>
      </van-sticky>
        <van-cell-group inset  style="margin-top : 10px" >
            <van-cell v-if = "exaList.length != 0">
                <template>
                    <van-grid :border="true" :gutter="10" contain square fill :column-num="3">
                        <van-grid-item v-for="itm in exaList" :key=itm.index>
                            <van-image :src="itm.url" style="border: solid 1px black;"/>
                            <van-tag type="danger" >{{itm.type}}</van-tag>
                        </van-grid-item>
                    </van-grid>
                </template>
            </van-cell> 
            <van-cell v-if = "exaList.length == 0">
                <template> 
                    还没有任何考试
                </template>
            </van-cell> 
        </van-cell-group>
       <!-- <van-cell style="background-color:aliceblue">
          <template #title>
            <van-pagination style="position: fixed; bottom:0 " v-model="currentPage" :total-items="24" :items-per-page="5" />
          </template>
        </van-cell>-->
    </div>
  </template>
  <script>
    import { Search } from 'vant';
    import  SERVICE_URL from '@/api/url'
    export default {
      name : 'examBank',
      data () {
        return {
            type : "姓名",
            value:"123123",
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            showPicker: false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            loginForm: {
            userName: '',
            password: ''  ,
            value: '',
            },
            exaList : [],
            quetions:[{aId : "A" , content:"顺序导致的问题"},{aId : "B" , content:"顺序导致的问题2"}],
            rules: {
            userName: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
            ],
            password: [
              { required: true, message: '请输入密码', trigger: 'blur' }
            ]
          },
          showLogin: false
        }
      },
      mounted () {
        for(let i = 0 ; i< 10 ; i++ ) {
                let item = {
                    type : "生物安全知识考试",
                    index : i,
                    url :"https://img01.yzcdn.cn/vant/apple-3.jpg"
                }
                this.exaList.push(item);
            }
            console.log(this.exaList);
        this.showLogin = true;
      },
      onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
              if (this.refreshing) {
                  this.list = [];
                  this.refreshing = false;
                }
                for (let i = 0; i < 10; i++) {
                    let item = {
                      id : i,
                      userName:"雷布斯" + i,
                      gender : "男",
                      email : "cxf@lrc.cn",
                      workNo : "2505",
                      deptName : "信息技术部",
                      phone : "18734148493"
                    }
                    this.list.push(item);
                }

                // 加载状态结束
                this.loading = false;
                
                // 数据全部加载完成
                if (this.list.length >= 40) {
                    this.finished = true;
                }
            }, 1000);
            for(let i = 0 ; i< 10 ; i++ ) {
                let item = {
                    type : "生物安全知识考试",
                    index : i,
                    url :"https://img01.yzcdn.cn/vant/apple-3.jpg"
                }
                this.exaList.push(item);
            }
            console.log(this.exaList);
        },
      methods: {
        onConfirm(value){

          this.showPicker = false;
          this.type = value;
        },
        openDialog(){

          this.showPicker = true;
        },
        onSearch(){

          

        },
        onClickLeft(){

        },
        onClickRight(){

        },
       
        async submitForm (loginInfo) {

          // this 是Vue 
          let _this = this
          let data =JSON.parse(JSON.stringify(this.loginForm))
          this.$refs[loginInfo].validate(async (valid) => {
            if (valid) {
                  _this.$store.commit(TOKEN_ID, "11111111111")
                  let URL  =  SERVICE_URL + '/user/login'; 
                    // _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
                    // _this.$store.commit('tokenId', response.data.data.tokenId)
                    _this.$router.push('manage')
                    _this.$message.success(response.data.message)
              //    axios.post(URL, data).then((response) => {
              //     if (response.data.code === 0) {
              //       // 这里进行存储信息
              //       // 跳转页
              //       _this.$store.commit(STORE_USER_INFO, _this.loginForm.userName)
              //       _this.$store.commit('tokenId', response.data.data.tokenId)
              //       _this.$router.push('manage')
              //       _this.$message.success(response.data.message)
              //     } else {
              //       _this.$message({
              //         showClose: true,
              //         message: response.data.message,
              //         type: 'error',
              //         duration: 0
              //       })
              //     }
              //   }).catch(function (err) {
              //       _this.$message({
              //         showClose: true,
              //         message: err.message,
              //         type: 'error',
              //         duration: 0
              //       })
              // });
            }
          })
        },
        onSearch (){


        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
      }
    }
  </script>
  
  <style lang="less" scoped>
      .title-class {
          width: 10%;

      }
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/question/examBank.vue